import { collectionEngineV1 } from '../apis.js';
const billingsAPI = collectionEngineV1('/billing-reasons');
export const get = (depositCaseVoucherId, billingId) => billingsAPI('GET', `/${depositCaseVoucherId}?${billingId ? `billingId=${billingId}` : ''}`);
//# sourceMappingURL=billing-reasons.js.map